export default function(to, from, next) {
    if(!localStorage.getItem('isAuth') || !localStorage.getItem('token')) {
        next('/auth/login?AccessDenied=true')
    } else {
        next()
    }
}